import { Helmet } from "react-helmet";
import bm from "../components/100-board-members/BoardMembers100.module.scss";
import Feeds from "../components/feeds/Feeds";
import EventChallengeMC from "../components/event-challenge-mc/EventChallengeMC";
import Csuitevideos from "../components/csuite-videos/Csuitevideos.js";
import Wisdom from "../components/wisdom/Wisdom";
import InsiprationZone from "../components/inspiration-zone/InsiprationZone";
import NewsletterLH from "../components/latest-happenings-newsletter/NewsletterLH.js";

export default function LatestHappening() {
  return (
    <div className={bm["page-wrapper"]}>
      <Helmet>
        <title>Latest Updates from Iron Lady Leadership Programs</title>
        <meta
          name="description"
          content="Get the latest updates on Iron Lady's top leadership program for women. Discover new batches, upcoming events, success stories, and program highlights designed to empower women and accelerate their leadership journey."
        />
        <link rel="canonical" href="https://iamironlady.com/latest" />
      </Helmet>

      <div id="latest-updates">
        <EventChallengeMC boardTheme />
        <Csuitevideos boardTheme />
        <NewsletterLH boardTheme />
        <InsiprationZone boardTheme />
        <Wisdom boardTheme />
        <Feeds boardTheme />
      </div>
    </div>
  );
}
